import React, { useEffect, useRef, useState } from 'react';

import { RevealDirection, Wrapper } from './styles';

interface RevealProps {
  direction?: RevealDirection;
  delay?: number;
  className?: string;
}

// Fade + translate ao entrar no viewport, uma vez só -- mesma ideia do
// script de reveal do design de referência (`data-reveal`), reescrito
// como IntersectionObserver em vez de polling em requestAnimationFrame.
const Reveal: React.FC<RevealProps> = ({
  direction = 'up',
  delay = 0,
  className,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.setTimeout(() => setRevealed(true), delay);
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [delay]);

  return (
    <Wrapper
      ref={ref}
      direction={direction}
      revealed={revealed}
      className={className}
    >
      {children}
    </Wrapper>
  );
};

export { Reveal };
